import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router";
import { api } from "../api";
import { useSession } from "../auth";
import { type Draft, DraftIssue } from "../components/issues/draft-issue";
import { PageSkeleton } from "../components/page";

export function NewIssuePage() {
  const [params] = useSearchParams();
  const parent = params.get("parent") || null;
  const metaQuery = useQuery({
    queryKey: ["issues-meta"],
    queryFn: api.issuesMeta,
    staleTime: 60_000,
  });
  const meta = metaQuery.data;
  const session = useSession();
  const [draft, setDraft] = useState<Draft | null>(null);
  const createdAt = useRef(new Date().toISOString()).current;

  useEffect(() => {
    if (!meta || draft) return;
    const type = [...meta.types].sort((a, b) => a.position - b.position)[0];
    const status =
      meta.statuses.find((item) => item.key === "backlog") ??
      [...meta.statuses].sort((a, b) => a.position - b.position)[0];
    const reporter = meta.users.find((user) => user.email.toLowerCase() === session.email.toLowerCase());
    setDraft({
      title: "",
      description: "",
      typeKey: type?.key ?? "bug",
      statusKey: status?.key ?? "backlog",
      repoKey: null,
      priority: 0,
      storyPoints: null,
      reviewerId: null,
      reporterId: reporter?.id ?? null,
      teamIds: null,
      labelIds: [],
      parent,
    });
  }, [meta, draft, parent, session.email]);

  if (!meta || !draft) return <PageSkeleton />;

  return <DraftIssue draft={draft} setDraft={setDraft} meta={meta} parent={parent} createdAt={createdAt} />;
}
